export const getMarginBottom = (
  isMobile: boolean,
  index: number,
  isRTL: boolean
) => {
  if (isMobile) return 4;
  if (index === 0 || index === 1) {
    return isRTL ? "10px" : "20px";
  }
  return "";
};

export const getMarginTop = (isMobile: boolean, index: number) => {
  if (isMobile) return "5px";
  if (index === 0 || index === 1) return "";
  return "22px";
};

export const getMarginLeft = (
  isMobile: boolean,
  isRTL: boolean,
  index: number
) => {
  if (isMobile) return 0;
  if (!isRTL) {
    return index % 2 === 1 ? 3 : 0;
  } else {
    return index % 2 === 0 ? 3 : 6;
  }
};

export const getMarginRight = (
  isMobile: boolean,
  isRTL: boolean,
  index: number
) => {
  if (isMobile) return 0;
  if (!isRTL) {
    return index % 2 === 0 ? 3 : 2;
  } else {
    return index % 2 === 1 ? 3 : 6;
  }
};
